module.exports = __webpack_public_path__ + "img/14.267d5190.png";